import React from "react";

import Header from "../../components/Header";
import Intro from "../../components/Intro";
import ServicesProvided from "../../components/ServicesProvided";
import Feedback from "../../components/Feedback";
import WhoAreWe from "../../components/WhoAreWe";
import OurTeam from "../../components/OurTeam";
import Contact from "../../components/Contact";
import Footer from "../../components/Footer";

export default function Home() {
  return (
    <div>
      <Header />
      <Intro />
      <ServicesProvided />
      <Feedback />
      <WhoAreWe />
      <OurTeam />
      <Contact />
      <Footer />
    </div>
  );
}